<template>
    <div>
        <Header title="课程详情"></Header>
        <van-tabs color="#7181EB" title-active-color="#7181EB" v-model="active" @change="requestData">
            <van-tab :title="item.name" v-for="(item,index) in subjects" :key="index">
                <div class="tab-con-wrap" v-if="item.content.name">
                    <div class="header">
                        <img :src="item.content.cover" />
                        <div class="body">
                            <div class="title">
                                <p>{{item.content.name}}</p>
                                <span>座位费￥<span>{{item.content.seat_fee}}</span></span>
                            </div>
                            <div>
                                <img :src="Images.icon_time" alt="">
                                <p>开放时间：</p>
                            </div>
                            <p class="text">{{item.content.start_time}} 至 {{item.content.end_time}}</p>
                            <div>
                                <img :src="Images.icon_address" alt="">
                                <p>上课地点：</p>
                                <div @click="showLocation" :data-lat="item.content.lat" :data-lng="item.content.lon" :data-title="item.content.address"  :data-desc="item.content.area + item.content.address">
                                    <img :src="Images.icon_nav" alt="">
                                    <p>导航</p>
                                </div>
                            </div>
                            <p class="text">{{item.content.area}}{{item.content.address}}</p>
                            
                            <div class="title-wrap">
                                <span class="icon icon-warning"></span>
                                <span class="title-text">课程提醒</span>
                            </div>
                            <div class="detail-wrap">{{item.content.student_warn}}</div>

                            <div class="title-wrap">
                                <span class="icon icon-detail"></span>
                                <span class="title-text">课程详情</span>
                            </div>
                            <div class="detail-wrap" v-html="item.content.desc"></div>
                            <div class="tell none">
                                <img :src="Images.icon_salon_inheritor" alt="">
                                <span>咨询顾问：</span>
                                <span v-if="service&&service.customer_service">{{service.customer_service.name}} {{service.customer_service.mobile}}</span>
                                <span v-else>******</span>
                            </div>
                        </div>
                    </div>
                    <div class="footer">
                        <div class="btn btn1" @click="onPressNav('courseDetailEnroll', {id:stage_id, type: Constants.USER_WORKER})">报名义工</div>
                        <div class="btn btn2" @click="onPressNav('courseDetailEnroll', {id:stage_id, type: Constants.USER_STUDENT})">报名上课</div>
                        <!-- <div class="btn">报名退款</div> -->
                    </div>
                </div>
                <div class="tab-con-wrap" v-else>
                    <van-empty description="暂无信息～" />
                </div> 
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import {wxSetup, wxShare} from '@/utils/wxShare'
import Header from '@/components/Header'
import {mapGetters} from 'vuex'
import Lockr from 'lockr'
export default {
    /** 组件挂载 */
    components: {
        'Header': Header
    },
    /** 数据区 */
    data() {
        return {
            active: 0,
            stage_id: "",
            subject_id: "",
            subjects: [],
            dataSources: {}
        };
    },
    /** 计算 */
    computed: {
        ...mapGetters(["userInfo", "service"]),
    },
    /** 挂载前 */
    created () {
        this.stage_id = this.$route.query.id
        this.requestDataTab();
    },
    mounted() {
        setTimeout(() => {
            this._setupWechatConfig();
        }, 500);
    },
    methods: {

        // 设置分享参数
        async _setupWechatConfig() {
            let url = this.API.wx_setup_info;
            let data = {
                page_flag: 'common',
                share_url: window.location.href.split('#')[0],
            };

            let _urlTemp = window.location.href;
            if (_urlTemp.indexOf('is_share=1&uid=') > -1) {
                _urlTemp = _urlTemp.split('is_share=1&uid=')[0] + 'is_share=1&uid=' + this.userInfo.id;
            } else {
                _urlTemp = _urlTemp + '&is_share=1&uid=' + this.userInfo.id;
            }

            console.log('this.userInfo, _urlTemp---->', this.userInfo, _urlTemp);

            // 非微信环境直接退出
            if (!this.$isWeiXin()) return;
            let result = await this.$post(url, data);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                let share_params = {
                    ...result.data.share_params,
                    title: this.subjects[this.active].content.name,
                    desc: this.subjects[this.active].content.share_desc,
                    icon: this.subjects[this.active].content.cover,
                    link: _urlTemp,
                }
                wxShare(result.data.share_config, share_params, () => {});
            }
        },

        // 请求数据
        async requestDataTab() {
            let url = this.API.enroll_subject_detail;
            let params = {
                subject_stage_id: this.stage_id,
                subject_id: ""
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.subjects = result.data.subjects.map(item=>{
                    item.content = new Object()
                    return item
                })
                this.requestData()
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 切换tab
        async requestData() {
            let {active} = this
            let url = this.API.enroll_subject_detail;
            let params = {
                subject_stage_id: this.stage_id,
                subject_id: this.subjects[active].id
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.subjects[active].content = result.data.subject_stage_con
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 查看位置
        showLocation (e) {
            let {lat,lng,title,desc} = e.currentTarget.dataset
            let url = `https://api.map.baidu.com/marker?location=${lat},${lng}&title=${title}&content=${desc}&output=html`
            window.location.href = url
        },
        // 跳转
        onPressNav(router, query={}) {
            let token = this.Lockr.get('token')
            console.log('token---->', token);
            if (!token) {
                return this.$emit(this.Constants.SHOWLOGINDIALOG, true);
            }
            this.$router.push({path: '/'+router, query: query})
        }
    },
};
</script>

<style lang="less" scoped>
.scrollerView {
    position: relative;
    width: 100%;
}

.scroller {
    background: #F8F8F8;
}

.header {
    margin: 10px 15px 0;

    > img {
        display: block;
        width: 100%;
        min-height: 140px;
        background-color: #fff;
    }

    > .body {
        margin-top: 10px;
        padding: 10px;
        background: #fff;

        > .title {
            display: flex;
            align-items: center;
            p {
                font-size: 16px;
                color: #333;
                font-weight: 500;
                flex: 1;
            }

            span {
                font-size: 13px;
                color: #F83535;
                font-weight: 400;

                span {
                    font-size: 18px;
                }
            }
        }

        .title-wrap {
            .icon {
                color: #8294ed;
                font-size: 1rem;
                margin-right: 0.5rem;

                &.icon-detail {
                    font-size: 1.6rem;
                }

            }
        }


        > div {
            margin-top: 10px;
            display: flex;
            align-items: center;

            > img {
                width: 15px;
                height: 15px;
                margin-right: 5px;
            }

            > p {
                flex: 1;
                font-size: 14px;
                color: #333;
                font-weight: 500;

                > span {
                    font-size: 13px;
                    font-weight: 400;
                }
            }

            > div {
                display: flex;
                align-items: center;

                > img {
                    width: 20px;
                    height: 20px;
                    margin-right: 5px;
                }

                > p {
                    font-size: 14px;
                    color: #7181EB;
                }
            }
        }

        > .text {
            margin-top: 5px;
            font-size: 13px;
            color: #333;
        }

        .tell {
            margin-top: 10px;
            height: 53px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-image: url('../../assets/img/img_btn_bg1.png');
            background-size: cover;

            img {
                width: 13px;
                height: 17px;
                margin-right: 7px;
            }

            span {
                font-size: 13px;
                color: #fff;
            }
        }
    }
}

.footer {
    position: fixed;
    left: 0;
    bottom: 0px;
    z-index: 10;
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
    display: flex;

    .btn {
        flex: 1;
        height: 40px;
        background: linear-gradient(225deg,#9cb2f4, #6472e8);
        border-radius: 3px;
        line-height: 40px;
        text-align: center;
        font-size: 15px;
        color: #fff;
        font-weight: 500;
    }
    
    .btn1 {
        height: 38px;
        margin-right: 15px;
        background: #fff;
        border: 1px solid #7181EB;
        color: #7181EB;
    }
}
</style>